import { HttpClientModule, HTTP_INTERCEPTORS, HttpRequest } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiModule, Configuration } from './shared/services/api';
import { SharedModule } from './shared/shared.module';
import { NgxUiLoaderModule, SPINNER, NgxUiLoaderHttpModule } from "ngx-ui-loader";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar'
import { TokenInterceptor } from './shared/services/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Merlin2023Module } from './merlin2023/merlin2023.module';
import { AuthHttpInterceptorExtended } from './shared/services/aut-extended.service';
import { QRCodeModule } from 'angularx-qrcode';


export function apiConfiguration() {
  return new Configuration({ basePath: environment.apiURL });
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    NgxChartsModule,
    Merlin2023Module,
    ApiModule.forRoot(apiConfiguration),
    NgxUiLoaderModule.forRoot({
      fgsType: SPINNER.threeStrings,
      blur: 5,
      fgsSize: 80,
      "overlayColor": "rgba(40, 40, 40, 0.1)",
      hasProgressBar: false,
      gap: 24,
      masterLoaderId: "master",

    }),
    NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    NgScrollbarModule,
    ToastrModule.forRoot(),
    AuthModule.forRoot({
      domain: 'ekitabu.eu.auth0.com',
      scope:'openid user_metadata',
      audience:'https://merlinauth/api',
      clientId: 'Op6ody7TWV4uPcLBXCZ3jRA7UYuk1Yxp',
      httpInterceptor: {
        allowedList: [{
          uri:environment.apiURL+"/*",
          tokenOptions: {

          }

          }]
      }
    }),
    FlexLayoutModule,
    QRCodeModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHttpInterceptorExtended,
    multi: true,
  },{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  },
  { provide: LOCALE_ID, useValue: 'en-GB' },
  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  },
  { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
